// extracted by mini-css-extract-plugin
module.exports = {"row":"PharmacyQuickFilters_row__WZAYx","chip":"PharmacyQuickFilters_chip__crOcH","wordmark":"PharmacyQuickFilters_wordmark__JfZ0A"};